import type { InsightPatientRow } from "src-next/modules/clinical-insights/types/insightWorkspaceTypes";

export function computePatientCountMaps(patientRows: InsightPatientRow[]) {
  const byStatus = new Map<string, Set<string>>();
  const byItem = new Map<string, Set<string>>();
  const bySecondary = new Map<string, Set<string>>();

  for (const row of patientRows) {
    for (const item of row.items) {
      if (!byStatus.has(item.statusKey)) {
        byStatus.set(item.statusKey, new Set());
      }
      byStatus.get(item.statusKey)!.add(row.patientId);

      if (!byItem.has(item.itemKey)) {
        byItem.set(item.itemKey, new Set());
      }
      byItem.get(item.itemKey)!.add(row.patientId);

      if (item.secondaryKey) {
        if (!bySecondary.has(item.secondaryKey)) {
          bySecondary.set(item.secondaryKey, new Set());
        }
        bySecondary.get(item.secondaryKey)!.add(row.patientId);
      }
    }
  }

  const toRecord = (map: Map<string, Set<string>>) => {
    const out: Record<string, number> = {};
    for (const [key, ids] of map.entries()) {
      out[key] = ids.size;
    }
    return out;
  };

  return {
    patientCountByStatus: toRecord(byStatus),
    patientCountByItem: toRecord(byItem),
    patientCountBySecondary: toRecord(bySecondary),
  };
}
